import { type ReactNode } from "react";

import { cn, Icon, Text } from "@flare/ui";

import { useFunnelExperimentContext } from "../funnel-experiment-context";

export function StepFeedback({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  const funnelExperimentContext = useFunnelExperimentContext();

  if (!funnelExperimentContext.feedbackButtonsShown) {
    return null;
  }

  return (
    <div
      className={cn(
        "mx-auto mt-sp-0 grid h-s-0 w-full max-w-[520px] grid-cols-[min-content_1fr] gap-sp-2 rounded-md bg-info px-sp-4 py-sp-0 opacity-0 transition-opacity",
        className,
        {
          "mt-sp-3 py-sp-3 h-auto opacity-100": children,
        },
      )}
    >
      <Icon name="bulb" size="sm" />
      <Text variant="body2">{children}</Text>
    </div>
  );
}
